import type { UploaderMethodProps } from 'src/app/shared/components/imageUpload';

import type { ImageData } from './types';

export async function saveImage(uploader: UploaderMethodProps | null): Promise<ImageData> {
	try {
		if (!uploader) throw new Error('Uploader is null');

		const { upload } = uploader;
		const { successful, failed } = await upload();

		if (failed.length > 0) {
			throw new Error(failed[0].error);
		}

		if (!successful[0].uploadURL) {
			throw new Error('Bad URL returned from upload');
		}
		return successful[0];
	} catch (e: unknown) {
		const message = e instanceof Error ? e.message : 'Unexpected error';
		throw new Error(message);
	}
}
